import React from 'react';

const PolicyCardContent = ({currentMode, category, content,
  policy_makers, regional_info, effective_date, showAll, cardInProfileUrl}) => {

    const date = new Date(effective_date)
    const date_object = date.toISOString().split('T')[0]

    return (
        <div className={` ${!currentMode ? `bg-chatTipBackground text-black`
                            :
                              `bg-nightModeDark_200 text-white `}
                        rounded-t-lg px-4 py-4 space-y-2.5
                         border-nightModeDark_600 border-2 shadow-lg 
                         ${cardInProfileUrl ? "text-xs" : "text-sm sm:text-[16px]" }
                         `}>
                        <h1
                        className={`
                        ${cardInProfileUrl ? "" : "text-xl" }
                         font-bold `}>
                         <span className='font-normal text-[16px]'>
                         {category.length > 1 ? "Categories" : "Category"}: </span>
                        {category && category.map((item,idx) => 
                          ( <span key={idx}>{item}{idx === (category.length - 1) ? "." : ", "} </span>)
                          )}
                          </h1>
                        <p><span className=''>
                        Policy Makers:</span> {policy_makers} </p>

                        <p><span className=''>
                        Region:</span>  {regional_info}</p>

                        <p><span className=''>
                        Date Generated:</span> <b>{date_object}</b></p>

                        <div 
                        className={`text-white p-4 rounded-md 
                        ${!currentMode ? `bg-updatedPurple` : `bg-greenOnDarkMode`}`}>

                          {showAll ? 
                          <>
                            {content.map((item, idx) => <p key={idx}  className={`inter-justify my-4`}> {item}</p> )}
                          </> 
                          : 
                          <p className={`inter-justify`}> {content && content[0].substring(0, 200)} </p>
                          }
                        </div>
                    </div>
    );
}

export default PolicyCardContent;
